import { Mapper } from "../../../../base/utils/mapper";
import { TypeLookModel } from "../../../../domain/models/consult/type-look.model";
import { TypeLookEntity } from "../entities/type-look.entity";

export class TypeLookImplementationRepositoryMapper extends Mapper<TypeLookEntity, TypeLookModel> {
    mapFrom(param: TypeLookEntity): TypeLookModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: TypeLookModel): TypeLookEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}